import EventUtils from '@/utils/EventUtils.js';
import MapUtils from '@/utils/MapUtils.js';
import ConstUtils from '@/utils/ConstUtils.js'
import RcResponseEvent from '@/domain/model/events/RcResponseEvent.js';

import CheckListVersionMap from '@/domain/model/checklist/version/CheckListVersionMap.js';
import CheckListVersion from '@/domain/model/checklist/version/CheckListVersion.js';

// The frozen checklist copies the inspection details reply carries alongside its results.
const state = {
  list: [],
  map: {},
};

const getters = {
  CheckListVersionStorage: state => state,
};

const actions = {
};

const mutations = {
  SOCKET_ONMESSAGE (state, event)  {
    if (event.status == EventUtils.STATUS.COMPLETE && event.statusCode == EventUtils.CODE.OK) {
      var payload = event[RcResponseEvent.Fields.PAYLOAD];
      if (payload) {
        var map = payload[CheckListVersionMap.MODEL_NAME];
        if (map) {
          state.map = MapUtils.updateMap(map, state.map);
        }
        var item = payload[CheckListVersion.MODEL_NAME];
        if (item && typeof item === 'object' && item[ConstUtils.FIELDS.ID]) {
          state.map[item[ConstUtils.FIELDS.ID]] = item;
        }
        if (map || item) {
          state.list = Object.values(state.map);
        }
      }
    }
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
